import SearchFiltersOverlayList from './SearchFiltersOverlayList';

export default SearchFiltersOverlayList;
